var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91288 6.34584V7.70738H7.47461C6.64618 7.70738 5.97461 8.37896 5.97461 9.20738C5.97461 10.0358 6.64618 10.7074 7.47461 10.7074H8.91288V11.9978C8.66631 12.1127 8.38397 12.1701 8.06586 12.1701H1.9862C1.42507 12.1701 0.975237 11.9914 0.636705 11.6339C0.298172 11.2764 0.128906 10.789 0.128906 10.1717C0.128906 9.89905 0.137022 9.63285 0.153253 9.37307C0.169484 9.1133 0.201946 8.83296 0.250639 8.53203C0.299332 8.23111 0.360778 7.95205 0.434976 7.69485C0.509175 7.43765 0.60888 7.18688 0.73409 6.94254C0.859301 6.6982 1.00306 6.48987 1.16537 6.31754C1.32768 6.14522 1.52593 6.00762 1.76012 5.90474C1.99431 5.80186 2.25285 5.75042 2.53573 5.75042C2.58211 5.75042 2.68181 5.80571 2.83484 5.91631C2.98788 6.02691 3.15715 6.15036 3.34264 6.28668C3.52814 6.42299 3.77624 6.54645 4.08695 6.65705C4.39766 6.76764 4.71068 6.82294 5.02603 6.82294C5.34137 6.82294 5.6544 6.76764 5.96511 6.65705C6.27582 6.54645 6.52392 6.42299 6.70941 6.28668C6.89491 6.15036 7.06418 6.02691 7.21721 5.91631C7.37025 5.80571 7.46995 5.75042 7.51633 5.75042C7.79921 5.75042 8.05775 5.80186 8.29194 5.90474C8.52613 6.00762 8.72438 6.14522 8.88669 6.31754C8.89547 6.32687 8.90421 6.3363 8.91288 6.34584ZM6.91462 5.37619C7.43633 4.79749 7.69719 4.09919 7.69719 3.2813C7.69719 2.4634 7.43633 1.76511 6.91462 1.18641C6.39291 0.607709 5.76338 0.318359 5.02603 0.318359C4.28868 0.318359 3.65915 0.607709 3.13744 1.18641C2.61573 1.76511 2.35487 2.4634 2.35487 3.2813C2.35487 4.09919 2.61573 4.79749 3.13744 5.37619C3.65915 5.95489 4.28868 6.24424 5.02603 6.24424C5.76338 6.24424 6.39291 5.95489 6.91462 5.37619Z",
    fill: "#572148"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4129 5.65186V12.7629V5.65186ZM7.47461 9.20738H13.3512H7.47461Z",
    fill: "#572148"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4129 5.65186V12.7629M7.47461 9.20738H13.3512",
    stroke: "#572148",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/Team.a49acde41e80f9571faa569d0a643b4c.svg";
export { ForwardRef as ReactComponent };